import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "inquiry confirm"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { style: { "white-space": "pre-line" } };
import { ref, computed, onBeforeMount } from 'vue';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import InertiaUtil from '@util/InertiaUtil';
export default /*@__PURE__*/ _defineComponent({
    __name: 'inquiry_check',
    props: {
        common: {},
        form: {}
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f;
        const props = __props;
        const form = InertiaUtil.getForm({
            name: (_a = props.form.name) !== null && _a !== void 0 ? _a : '',
            email: (_b = props.form.email) !== null && _b !== void 0 ? _b : '',
            tel: (_c = props.form.tel) !== null && _c !== void 0 ? _c : '',
            inquiry_type_id: (_d = props.form.inquiry_type_id) !== null && _d !== void 0 ? _d : null,
            subject: (_e = props.form.subject) !== null && _e !== void 0 ? _e : '',
            content: (_f = props.form.content) !== null && _f !== void 0 ? _f : '',
        });
        const options = ref([]);
        const showType = computed(() => {
            var _a, _b;
            const option = (_a = options.value.find(value => value.id === form.inquiry_type_id)) !== null && _a !== void 0 ? _a : null;
            return (_b = option === null || option === void 0 ? void 0 : option.name) !== null && _b !== void 0 ? _b : '';
        });
        const onClickReturn = () => {
            window.history.back();
        };
        const onSend = () => {
            InertiaUtil.post(form, route('inquiry.store'));
        };
        onBeforeMount(() => {
            axios.get(route('inquiry-types')).then(response => {
                var _a;
                options.value = (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : null;
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[8] || (_cache[8] = _createElementVNode("h2", null, "お問合せ", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[7] || (_cache[7] = _createStaticVNode("<p class=\"lead\">当社へのお問い合わせは下記お問い合わせフォームよりお送りください。</p><ul class=\"step_3\"><li class=\"off2\">入力</li><li class=\"active\">確認<i class=\"fas fa-caret-up step-triangle\"></i></li><li class=\"off\">完了</li></ul>", 2)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSend, ["prevent"])
                                }, [
                                    _createElementVNode("dl", null, [
                                        _cache[0] || (_cache[0] = _createElementVNode("dt", null, "お名前", -1)),
                                        _createElementVNode("dd", null, _toDisplayString(_unref(form).name), 1),
                                        _cache[1] || (_cache[1] = _createElementVNode("dt", null, "メール", -1)),
                                        _createElementVNode("dd", null, _toDisplayString(_unref(form).email), 1),
                                        _cache[2] || (_cache[2] = _createElementVNode("dt", null, "電話番号", -1)),
                                        _createElementVNode("dd", null, _toDisplayString(_unref(form).tel), 1),
                                        _cache[3] || (_cache[3] = _createElementVNode("dt", null, "種類", -1)),
                                        _createElementVNode("dd", null, _toDisplayString(showType.value), 1),
                                        _cache[4] || (_cache[4] = _createElementVNode("dt", null, "件名", -1)),
                                        _createElementVNode("dd", null, _toDisplayString(_unref(form).subject), 1),
                                        _cache[5] || (_cache[5] = _createElementVNode("dt", null, "内容", -1)),
                                        _createElementVNode("dd", _hoisted_5, _toDisplayString(_unref(form).content), 1)
                                    ]),
                                    _createElementVNode("div", { class: "bt_box" }, [
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    id: "submit-button",
                                                    class: "bt_back",
                                                    onClick: onClickReturn,
                                                    value: "戻る"
                                                }, " 戻る ")
                                            ]),
                                            _cache[6] || (_cache[6] = _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    id: "submit-button",
                                                    class: "bt_next",
                                                    value: "送信する"
                                                }, " 送信する ")
                                            ], -1))
                                        ])
                                    ])
                                ], 32)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
